// import axios from "axios";
// import { API_URL } from "./constants";
// import { getAccessToken } from "./localStorage";
// // import { toast } from "react-toastify";

// const instance = axios.create({
//   baseURL: API_URL
// });

// instance.all = axios.all;
// instance.spread= axios.spread;

// instance.interceptors.request.use(config => {
//   if (getAccessToken()) {
//     const token = `Token ${getAccessToken() || ""}`;
//     config.headers.Authorization = token;
//   }
//   return config;
// });

// instance.interceptors.response.use(
//   response => {
//     return response;
//   },
//   function(error) {
//     if (error.response && error.response.status === 401) {
//       // window.location = "/login";
//       // localStorage.clear();
//       // toast("Session timed out. Please login to continue.", {
//       //   autoClose: 5000,
//       //   type: toast.TYPE.ERROR
//       // });
//       return Promise.reject(error);
//     } else {
//       return Promise.reject(error);
//     }
//   }
// );

// export default instance;



// Updated Interceptor, Handled ihcl dashboard
import axios from "axios";
import { API_URL } from "./constants";
import { getAccessToken } from "./localStorage";

const instance = axios.create({
  baseURL: API_URL
});

instance.all = axios.all;
instance.spread = axios.spread;

instance.interceptors.request.use(config => {
  // console.log(config, ">>>>Config in axios");
  const ihclEndpoints = ["/reports/ihcl_count/", "/record-transaction-ihcl/", "/combined_ihcl_data/", "/record-transaction-ihcl-expenses/", "/reports/ihcl_market_linkage/", "/reports/ihcl_firsttimeusers/", "/reports/ihcl_compliance_data/", "/reports/ihcl_group_knowledge_session_data/", "/reports/ihcl_expert_consultation_data/", "/reports/ihcl_market_linkage_data/", "/reports/ihcl_social_media_data/", "/combinedihcl_resourcedisplayname/"];

  let ifIhclUrl = config.url;

  if (!config.signal) {
    if (!window.__axiosGlobalAbortController__) {
      window.__axiosGlobalAbortController__ = new AbortController();
    }
    config.signal = window.__axiosGlobalAbortController__.signal;
  }
  // Validate if the endpoint is of IHCL Dash board
  if (config.url && ihclEndpoints.includes(ifIhclUrl)) {
    // console.log(">>>entered if block of request interceptor");
    
    config.headers.Authorization = "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3";
  } else if (getAccessToken()) {
    // console.log(">>>entered else block of request interceptor");
    
    const token = `Token ${getAccessToken() || ""}`;
    config.headers.Authorization = token;
  }
  return config;
});

// Interceptor to handle responses
instance.interceptors.response.use(
  response => {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      // Optionally handle unauthorized access (e.g., redirect to login)
      return Promise.reject(error);
    } else if(error.response && error.response.status === 400) {
        return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export default instance;
